<template>
  <div class="container">
    <app-header title="我的收藏"/>
    <van-search v-model="value" @search="_queryCollectAndProduct" placeholder="搜索商品名称或型号，例如：电子商品" />
    <div class="recommend-content">
      <van-row gutter="10">
        <van-col span="12" v-for="item in productList" :key="item.id">
          <div class="item" @click="onNavigate(item)">
            <img :src="item.img" alt="goods03" width="170" height="170">
            <div class="content">
              <div class="name ellipsis-2">{{item.name}}</div>
              <div class="footer">
                <span class="price">￥{{item.price}}</span>
                <div>
                  <img src="@/assets/collect01.png" alt="收藏" width="30" height="30" @click.stop="_saveShopCollect(item)">
                  <img src="@/assets/mycart.png" alt="加入购物车" width="30" height="30" @click.stop="addCart(item)">
                </div>
              </div>
            </div>
          </div>
        </van-col>
      </van-row>
      <empty v-if="productList.length==0"/>
    </div>
  </div>
</template>

<script>
import { addShopCart } from '@/api/cart'
import { queryCollectAndProduct,saveShopCollect,updateShopCollect } from '@/api/collect/index.js'
export default {
  name: 'Index',
  data() {
    return {
      value: '',
      productList:''
    }
  },
  created() {
    this._queryCollectAndProduct()
  },
  methods: {
    // 取消收藏
    _saveShopCollect (item) {
      const params = {
        id: item.id,
        iscollect: 0
      }
      updateShopCollect(params).then((res) => {
        if (res.success) {
          if (params.iscollect){
            this.$toast.success('收藏成功')
          } else{
            this.$toast.success('取消收藏成功')
          }
          this._queryCollectAndProduct()
        }
      })
    },
    addCart(item){
      var user = localStorage.getItem('userInfo')
      if (!user){
        this.$router.push({
          path: '/login'
        })
        return;
      }
      user = JSON.parse(user)
      const form = {
        uid: user.id,
        pid: item.pid,
      }
      addShopCart(form).then(res => {
        if (res.success) {
          this.$toast({
            message: '已添加至购物车',
            duration: 1500
          })
        }
      })
    },
    _queryCollectAndProduct() {
      let user = JSON.parse(localStorage.getItem("userInfo"))
      const params = {
        uid: user.id,
        iscollect: 1,
        shopProduct:{
          name: this.value
        }
      }
      queryCollectAndProduct(params).then((res) => {
        if (res.success) {
          this.productList = res.data
        }
      })
    },
    onNavigate(item) {
      this.$router.push({
        path: 'product/detail',
        query: { id: item.pid }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    .recommend-content{
      padding: 10px 12px;
      background: #ffffff;
      .item{
        border:1px solid rgba(243,243,243,1);
        .name{
          font-size:14px;
          font-weight:bold;
          line-height:17px;
          color:rgba(51,51,51,1);
          opacity:1;
        }
        .footer{
          display: flex;
          justify-content: space-between;
          .price{
            height:30px;
            font-size:16px;
            font-weight:bold;
            line-height:30px;
            color:rgba(254,0,59,1);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/collect/index.vue